import {dataResult, type Result} from "@vesta/error-handling-remix/result";

/** Read the complete result before applying client-side sorting or pagination. */
export async function loadAllPages<T>({
    fetchPage,
    pageSize,
}: {
    fetchPage: (offset: number) => Promise<Result<Array<T>>>;
    pageSize: number;
}): Promise<Result<Array<T>>> {
    const rows: Array<T> = [];
    let offset = 0;
    while (true) {
        const result = await fetchPage(offset);
        if (result.success !== true) {
            return result;
        }
        rows.push(...result.data);
        if (result.data.length < pageSize) {
            return dataResult(rows);
        }
        offset += result.data.length;
    }
}
